if (!customElements.get('quantity-counter')) {
  customElements.define(
    'quantity-counter',
    class QuantityCounter extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change-input', {bubbles: true});
        this.buttonClickEvent = this.onButtonClick.bind(this);
        this.onQuantityChangeEvent = this.onQuantityChange.bind(this);

        this.input.addEventListener('change', this.onQuantityChangeEvent);
        this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.buttonClickEvent));
      }

      onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        const button = event.target.nodeName == 'BUTTON' ? event.target : event.target.closest('button');

        if (button.name === 'increase') this.input.stepUp();
        if (button.name === 'decrease') this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

        if (this.closest('.product-quick-add')) {
          const parent = this.closest('.product-quick-add');
          const qtyInput = parent.querySelector('.product__block--buttons .product__submit__item input[name="quantity"]');

          if (previousValue !== this.input.value) {
            qtyInput.value = this.input.value;
            qtyInput.dispatchEvent(this.changeEvent);
          }

          this.updateAllPrices(parent, this.input.value);

          parent.setAttribute('data-line-qty', this.input.value);

          const cart_message = parent?.querySelector('.product-quick-add__cart_message');
          if (cart_message) {
            let cart_message_span = cart_message.querySelector('span');
            const modalCheckedVariant = parent.getAttribute('data-variant');
            if (this.input.value >= 2 && modalCheckedVariant !== '') {
              cart_message.style.display = 'block';
              cart_message_span.textContent = this.input.value;
            } else {
              cart_message.style.display = 'none';
            }
          }
        }

        if (this.input.name == 'updates[]') {
          this.updateCart();
        }
      }

      updateAllPrices(parent, multiplier) {
        if (!parent) return;

        const prices = parent.querySelectorAll(
          '.prod-price, .selling-price, .product__price--strike, .product__price-sale'
        );

        prices.forEach(el => {
          let rawValue;

          if (el.classList.contains('prod-price')) {
            rawValue = el.dataset.prodPrice;
          } else if (el.classList.contains('selling-price')) {
            rawValue = el.dataset.sellingPrice;
          } else if (el.classList.contains('product__price--strike')) {
            rawValue = el.dataset.priceStrike;
          } else if (el.classList.contains('product__price-sale')) {
            rawValue = el.dataset.priceSale;
          }

          if (!rawValue) return;

          const value = parseFloat(rawValue.replace(/[^0-9.]/g, ''));
          if (isNaN(value)) return;

          const newValue = (value * multiplier).toFixed(2);

          el.textContent = `$${newValue}`;
        });
      }


      onQuantityChange() {
        // Trigger cart update event if line item quantity is changed
        if (this.closest('.product-quick-add')) {
          const previousValue = this.input.value;
          const parent = this.closest('.product-quick-add');
          const qtyInput = parent.querySelector('.product__block--buttons .product__submit__item input[name="quantity"]');
          qtyInput.value = previousValue;
          qtyInput.dispatchEvent(this.changeEvent);

          this.updateAllPrices(parent, previousValue);
          parent.setAttribute('data-line-qty', this.input.value);
        }

        if (this.input.name == 'updates[]') {
          this.updateCart();
        }
      }

      updateCart() {
        if (this.quantityValue === '') return;

        this.dispatchEvent(
          new CustomEvent('theme:cart:update', {
            bubbles: true,
            detail: {
              id: this.input.dataset.id,
              quantity: this.input.value,
            },
          })
        );
      }
    }
  );
}
